import type { QueryClient } from '@tanstack/react-query'
import { upsertById } from './list-state'

export function upsertMatchingQueryItems<T extends { id: string }>(
  queryClient: QueryClient,
  queryKey: readonly unknown[],
  item: T,
): void {
  queryClient.setQueriesData<T[]>({ queryKey }, (current) =>
    current ? upsertById(current, item) : [item],
  )
}
